import {
    ARRIVAL_TYPE,
    DEPARTURE_TYPE,
} from '../../../constants';
import { TIMING_DEFAULT } from '../constants';
import * as types from '../types';

function _setTimingRange(state, action, key) {
    const {
        meta: filterId,
        payload: range,
    } = action;

    return {
        ...state,
        [filterId]: {
            ...state[filterId],
            timing: {
                ...state[filterId].timing,
                [key]: [...range],
            },
        },
    };
}

function setDepartureTimingRange(state, action) {
    return _setTimingRange(state, action, DEPARTURE_TYPE);
}

function setArrivalTimingRange(state, action) {
    return _setTimingRange(state, action, ARRIVAL_TYPE);
}

function _resetTime(state, action, key) {
    const { meta: filterId } = action;

    return {
        ...state,
        [filterId]: {
            ...state[filterId],
            timing: {
                ...state[filterId].timing,
                [key]: [...TIMING_DEFAULT],
            },
        },
    };
}

function resetDepartureTime(state, action) {
    return _resetTime(state, action, DEPARTURE_TYPE);
}

function resetArrivalTime(state, action) {
    return _resetTime(state, action, ARRIVAL_TYPE);
}

export default {
    [types.SET_DEPARTURE_TIMING_RANGE]: setDepartureTimingRange,
    [types.SET_ARRIVAL_TIMING_RANGE]: setArrivalTimingRange,
    [types.RESET_DEPARTURE_TIMING]: resetDepartureTime,
    [types.RESET_ARRIVAL_TIMING]: resetArrivalTime,
};
